import axios from '@/http/axios/index.js'


export default {
    getList(payload) {
        return axios.get('pre_expenses/list', { params: payload })
    },
    getExpense(payload) {
        return axios.get('pre_expenses/show', { params: payload })
    },
    getRanges(payload) {
        return axios.get('pre_expenses/catalog/ranges', { params: payload })
    },
    updateExpese(payload){
         return axios.post('pre_expenses/update-expense',  payload)
    },
    deleteExpense(payload){
         return axios.delete('pre_expenses/delete',  { params: payload })
    },
    approveExpense(payload) {
        return axios.post('pre_expenses/approved',  payload)
    },
    getFiles(payload){
         return axios.get('pre_expenses/files',  { params: payload })
    }
  
}